const PRODUCT_GROUPS = {
    ALL: 'all',
    DAZN: 'DAZN',
    NFL: 'NFL',
    LIGA_SEGUNDA: 'LigaSegunda',
    FIBA: 'FIBA',
    PGA_TOUR: 'PGA',
    RALLY_TV: 'RallyTV',
    TENNIS_TV: 'TennisTV'
};

export {PRODUCT_GROUPS};
